import React, { Component } from "react";
import { formatCurrency } from "./../../../../js/shared/utils";
import Button from "../../../shared/button/button";
import Modal from "./../../../shared/Modal/Modal";

class MarketAnalysisContent extends Component {
	constructor() {
		super();
		this.state = {
			showModalTest: false
		};
	}

	showModal = () => {
		this.setState({ showModalTest: true });
	};
	closeModal = () => {
		this.setState({ showModalTest: false });
	};
	render() {
		const { marketAnalysis, suffix, position, description, error, period } = this.props;
		const { showModalTest } = this.state;
		if (error) {
			return (
				<div className="col-xs-16 market-analysis-details">
					<div className="row text-center">
						<h5 className="error-text">No momento, não foi possível carregar os valores.</h5>
					</div>
				</div>
			);
		}

		if (!marketAnalysis) {
			return null;
		}

		return (
			<div className="col-xs-16 market-analysis-details">
				<div className="row">
					{marketAnalysis
						.filter(fidelity => {
							return fidelity.name.toLowerCase().indexOf("platinum") == -1 && fidelity.international !== "1";
						})
						.map((fidelity, position) => {
							return (
								<div key={position} className="col-xs-16 v-center-columns text-left plans">
									<p className="plan-name">{fidelity.name}</p>
									<p
										className={
											fidelity.hasOwnProperty(["percent" + suffix])
												? fidelity["percent" + suffix] >= 0
													? "plan-positive-value"
													: "plan-negative-value"
												: "plan-positive-value"
										}
									>
										<span className="average">Média: </span>
										{suffix == "24HoursAgo" && <br />}
										<strong className="average-value">
											{formatCurrency(fidelity["price" + suffix])}
										</strong>
										{suffix !== "24HoursAgo" && (
											<span className="variation">
												<br />
												Variação:{" "}
												{fidelity["percent" + suffix] >= 0
													? "+" + fidelity["percent" + suffix] + "%"
													: fidelity["percent" + suffix] + "%"}
											</span>
										)}
									</p>
								</div>
							);
						})}
				</div>
				<div className="row dot-div text-center">
					<p>
						<i className={`dot ${position == 0 ? "dot-primary" : "dot-grey"}`} />
						<i className={`dot ${position == 1 ? "dot-primary" : "dot-grey"}`} />
						<i className={`dot ${position == 2 ? "dot-primary" : "dot-grey"}`} />
						<i className={`dot ${position == 3 ? "dot-primary" : "dot-grey"}`} />
					</p>
				</div>
				<div className="text-center">
					<Button
						className="btn btn-gray-md-o"
						onClick={this.showModal}
						type="button"
						data-action="market-analysis-understand"
					>
						Entenda
					</Button>
					<Modal
						title="COTAÇÃO DE MILHAS"
						description={description}
						confirm="Ok, entendi"
						onConfirm={this.closeModal}
						onCancel={this.closeModal}
						show={showModalTest}
						fixed={true}
					/>
				</div>
			</div>
		);
	}
}

export default MarketAnalysisContent;
